/**
 * Application-wide constants.
 *
 * Environment-specific values (URLs, secrets, hostnames) belong in config.ts.
 * This file is for shared literals that appear in multiple files or are
 * likely to change with business decisions.
 */

/** Brand name shown in the header and browser tab title. */
export const BRAND_NAME = 'JustiziaLaw';

/** Default page size for paginated list views. */
export const DEFAULT_PAGE_SIZE = 25;

/**
 * Upper bound when exporting all rows (CSV export, etc.).
 * Acts as a "fetch everything" sentinel — should be larger than any real dataset.
 */
export const EXPORT_FETCH_LIMIT = 100_000;

/** Debounce delay (ms) for search inputs. */
export const SEARCH_DEBOUNCE_MS = 500;
